import React, { useEffect, useState } from "react";
import AuthHelper from "./AuthLib";
import PropTypes from "prop-types";
import LoadingIndicatorCentered from "../reusableComponents/LoadingIndicatorCentered";
import { mergeSuccessQueryParam } from "../../utils/stringConstants";

const MERGE_SUCCESS_STORAGE_KEY = "MERGE_SUCCESS_PENDING";

// Safe localStorage wrapper — guards against exceptions in private browsing
// mode, when storage quota is exceeded, or when storage is otherwise unavailable.
const safeLocalStorage = {
  getItem: (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      console.warn("localStorage.getItem unavailable:", e);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      console.warn("localStorage.setItem unavailable:", e);
    }
  },
  removeItem: (key) => {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      console.warn("localStorage.removeItem unavailable:", e);
    }
  }
};

export const AuthWrapper = (props) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    AuthHelper.getToken()
      .then((token) => {
        const windowHash = safeLocalStorage.getItem("URL_HASH");
        if (windowHash) {
          window.location.hash = windowHash;
          safeLocalStorage.removeItem("URL_HASH");
        }
        // Restore mergeSuccess query param if it was saved before auth redirect
        const pendingMergeSuccess = safeLocalStorage.getItem(
          MERGE_SUCCESS_STORAGE_KEY
        );
        if (pendingMergeSuccess) {
          safeLocalStorage.removeItem(MERGE_SUCCESS_STORAGE_KEY);
          const url = new URL(window.location.href);
          if (!url.searchParams.has(mergeSuccessQueryParam)) {
            url.searchParams.set(mergeSuccessQueryParam, "yes");
            window.history.replaceState(
              "replaceStateData",
              "replaceStateTitle",
              url.toString()
            );
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        if (err.code === "LOGIN_REQUIRED") {
          safeLocalStorage.setItem("URL_HASH", window.location.hash);
          // Preserve mergeSuccess query param across auth redirect
          const currentUrl = new URL(window.location.href);
          if (currentUrl.searchParams.has(mergeSuccessQueryParam)) {
            safeLocalStorage.setItem(MERGE_SUCCESS_STORAGE_KEY, "yes");
          }
          AuthHelper.startInteractiveAuth();
        } else {
          // Unexpected/Undocumented error
          // At this time maybe track these errors and report back to core domain
          setLoading(false);
        }
      });
  }, []);

  if (loading) {
    return (
      <div>
        <LoadingIndicatorCentered htmlId="auth-pending" size="large" />
      </div>
    );
  } else {
    return <div id="auth-wrapper">{props.children}</div>;
  }
};
AuthWrapper.propTypes = {
  children: PropTypes.node.isRequired
};
